<groupui-card background="white">
    <h3>{{'dashboard.historical-readouts-tile.title' | translate}}</h3>
    <div class="keyReadouts-container">
      {{currentReadoutNumber | placeholder}}
    </div>
    <p>{{'dashboard.historical-readouts-tile.subtitle' | translate}}</p>
  </groupui-card>
